export default {
    anchorTarget: '_blank',
    relValue: 'noopener',
};
//# sourceMappingURL=linkSettings.js.map